module.exports = __webpack_public_path__ + "static/media/notes.100699da.svg";